import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  GridContainer,
  GridItem,
  handleFormSubmission,
  InputFormField,
  SubmitFormButton,
  useAsyncCall,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { FormProvider } from "react-hook-form";
import { ContactsDetails } from "../../../../../types/contactsTypes";
import { createContactsValidationSchema } from "../../../../../yup/schema/contacts/contactsValidationSchema";
import React, { Fragment } from "react";
import { Typography } from "@mui/material";
import { updateContacts } from "../../../../../axios/api/services";
import { VIEW_TYPES } from "../../../../../config/view/types";
import { addViewObject } from "../../../../../store/redux/slice/ViewData/viewDataPage";
import { toast } from "react-toastify";

const ContactsForm = ({ contacts }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const dispatch = useAppDispatch();

  const { methods } = useReactHookForm<ContactsDetails>({
    defaultValues: contacts,
    validationSchema: createContactsValidationSchema,
  });

  const submit = (values) => {
    const saveChanges: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: updateContacts(values),
      reactHooksForm: { methods },
      onSuccess: (response) => {
        const viewType = VIEW_TYPES.CONTACTS_EDIT;
        const payload = { viewType, data: response };
        dispatch(addViewObject(payload));
        toast.success(t("m.save.data.success"));
      },
    };
    asyncCall(saveChanges);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleFormSubmission({ methods, onSubmitFn: submit, t })}>
        <GridContainer spacing={4}>
          <Fragment>
            <GridItem sm={4} md={4}>
              <InputFormField
                isDisabled={false}
                required={false}
                fieldName={"address"}
                labelCode={"l.detail.address"}
              />
            </GridItem>
            <GridItem sm={4} md={4}>
              <InputFormField
                isDisabled={false}
                required={false}
                fieldName={"infoCenter"}
                labelCode={"l.detail.infoCenter"}
              />
            </GridItem>
            <GridItem sm={4} md={4}>
              <InputFormField
                isDisabled={false}
                required={false}
                fieldName={"telephone"}
                labelCode={"l.detail.telephone"}
              />
            </GridItem>
            <GridItem sm={4} md={4}>
              <InputFormField isDisabled={false} required={false} fieldName={"fax"} labelCode={"l.detail.fax"} />
            </GridItem>
            <GridItem sm={4} md={4}>
              <InputFormField isDisabled={false} required={false} fieldName={"email"} labelCode={"l.detail.email"} />
            </GridItem>
            <GridItem sm={4} md={4}>
              <InputFormField
                isDisabled={false}
                required={false}
                fieldName={"website"}
                labelCode={"l.detail.website"}
              />
            </GridItem>
          </Fragment>
        </GridContainer>
        <GridContainer spacing={2}>
          <GridItem sm={12} md={12}>
            <Typography align={"right"}>
              <SubmitFormButton label={"l.btn.edit.contacts"} color={"success"} />
            </Typography>
          </GridItem>
        </GridContainer>
      </form>
    </FormProvider>
  );
};

export default ContactsForm;
